import { Link } from 'react-router'

import { useI18n } from '../i18n/context'

/** Small "Privacy · Terms" links for page footers. */
export function LegalLinks() {
  const { t } = useI18n()
  return (
    <p className="legal-inline small">
      <Link to="/privacy">{t('legal.privacy')}</Link>
      <span aria-hidden="true"> · </span>
      <Link to="/terms">{t('legal.terms')}</Link>
    </p>
  )
}
